import { BREAKPOINTS } from "@/settings";
import { useShowAds } from "@repo/shared/redux";
import { useSelector } from "react-redux";
import { useMediaQuery } from "usehooks-ts";

export const SimpleAdUnit = () => {
  const shouldShowAds = useShowAds();
  if (!shouldShowAds) return null;
  return <div id="pubnation-ad" />;
};

export const LeaderboardAdUnit = () => {
  const shouldShowAds = useShowAds();
  const isMobile = useMediaQuery(BREAKPOINTS.MOBILE.query);
  if (!shouldShowAds) return null;
  if (isMobile)
    return (
      <div className="h-17">
        <div className="mv_slot_target" data-slot="LeaderboardMobile" />
      </div>
    );
  return <div id="pubnation-leaderboard" className="min-h-22.5" />;
};
